import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cdnClient } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { VistaReferenceScheme } from '@vista-digital/cdn-client';
import { observer } from 'mobx-react';
import { useOccContext } from '../../context/occ/hooks/use-occ-context';
import { Image } from '../image/image';
import { ImagePlaceholderType } from '../image/types/placeholder-type';
const b = bemClassBuilder('v-item-image');
export const ItemImage = observer(({ item, className, cdnOptions, promotedLabel }) => {
    const { i18n, accessibilityText } = useOccContext();
    return (_jsxs("div", Object.assign({ className: b.block(undefined, className) }, { children: [_jsx(Image, { placeholderType: ImagePlaceholderType.ItemImage, className: b.element('img'), src: cdnClient.instance
                    .item(item.hoCode, { referenceScheme: VistaReferenceScheme.Global })
                    .image(cdnOptions), alt: i18n.template(accessibilityText.itemImageAltTextFormat, {
                    itemName: i18n.translatable(item.name)
                }) }), promotedLabel && _jsx("span", Object.assign({ className: b.element('promoted-label') }, { children: promotedLabel }))] })));
});
ItemImage.displayName = 'ItemImage';
